module.exports = __webpack_public_path__ + "img/perfil-procedimental.333c8c33.png";